var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxDoneNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42423_60601)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42423_60601",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42423_60601)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42423_60601)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_42423_60601",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 3H7.44444C4.98984 3 3 4.98984 3 7.44444V14.5556C3 17.0102 4.98984 19 7.44444 19H14.5556C17.0102 19 19 17.0102 19 14.5556V7.44444C19 4.98984 17.0102 3 14.5556 3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_42423_60601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 3H7.44444C4.98984 3 3 4.98984 3 7.44444V14.5556C3 17.0102 4.98984 19 7.44444 19H14.5556C17.0102 19 19 17.0102 19 14.5556V7.44444C19 4.98984 17.0102 3 14.5556 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5554 9.40043L11.2317 12.6002L10.1238 13.6668L9.01586 12.6002L9.02201 12.5942L7.44434 11.0589L8.55255 9.99225L10.1299 11.5278L13.4475 8.3335L14.5554 9.40043Z",
    fill: "#049981"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 3H7.44444C4.98984 3 3 4.98984 3 7.44444V14.5556C3 17.0102 4.98984 19 7.44444 19H14.5556C17.0102 19 19 17.0102 19 14.5556V7.44444C19 4.98984 17.0102 3 14.5556 3Z",
    stroke: "#E5E7EB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42423_60601",
    x: -6.38888,
    y: -4.6111,
    width: 34.7778,
    height: 34.7778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.77778
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.44444
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.2 0 0 0 0 0.301961 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42423_60601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42423_60601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42423_60601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxDoneNew);
export default __webpack_public_path__ + "static/media/CheckboxDoneNew.8dd821c81bc9de44271c81732171261e.svg";
export { ForwardRef as ReactComponent };